<script setup lang="ts">
import ViewLayout from '@/views/layouts/ViewLayout.vue'
import CreatePolicyDialog from '@/components/asicw/policies/create-dialog/CreatePolicyDialog.vue'
import { ref } from 'vue'
import PoliciesTable from '@/components/asicw/policies/PoliciesTable.vue'
import BulkPolicyChangesDialog from '@/components/asicw/policies/BulkPolicyChangesDialog.vue'
import type { IPolicy } from '@/types/asicw/policies'
import { useOIDCStore } from '@/stores/oidc.store'
import { Plus } from '@element-plus/icons-vue'

const isFetching = ref(false)
const createDialogVisible = ref(false)
const bulkChangesDialogOpen = ref(false)
const tableSelection = ref<IPolicy[]>([])

const { isASICWOperationalUser } = useOIDCStore()
</script>

<template>
  <ViewLayout>
    <!-- Bulk changes dialog -->
    <BulkPolicyChangesDialog v-model="bulkChangesDialogOpen" :policies="tableSelection" />
    <CreatePolicyDialog v-model="createDialogVisible" />
    <template #controls>
      <!-- Enabled when there's any policies selected -->
      <el-button
        v-if="isASICWOperationalUser && tableSelection.length"
        class="w-max"
        @click="bulkChangesDialogOpen = true"
        >Change Policies</el-button
      >
      <el-button
        v-if="isASICWOperationalUser"
        type="primary"
        :disabled="isFetching"
        :icon="Plus"
        @click="createDialogVisible = true"
        >Create Policy</el-button
      >
    </template>
    <PoliciesTable v-model="tableSelection" />
  </ViewLayout>
</template>
